import RegisterForm from '../components/Register';
import Navbar from '../components/header/Navbar';
import Footer from '../components/Footer';
import { useEffect } from 'react';
import { useUser } from "../contexts/UserContext";
import { useNavigate } from "react-router-dom";

export default function RegisterPage() {
    const { user } = useUser();
    const navigate = useNavigate();

    useEffect(()=>{
        if (user){
            navigate('/dashboard');
        }
    }, [user]);
    return (
        <>
            <Navbar />
            <div className='h-screen flex items-center bg-gradient-to-tr from-[#14614E] to-[#848731]'>
                <div className='flex flex-col items-center m-auto w-full md:w-2/4 shadow-2xl bg-background rounded-t'>
                    <div className="flex w-full p-4 md:p-5 border-b rounded-t bg-primary">
                        <h3 className="text-xl font-semibold text-white">REGISTER</h3>
                    </div>
                    <RegisterForm />
                </div>
            </div>
            <Footer />
        </>
    );
}